import type { ConversationAppRun } from '@contexts/ConversationsContextStore';

const SHARED_APP_PREFIX = '/apps/shared/';

/** The SPA URL a public link opens; the token never travels in an API path. */
export const sharedAppPath = (token: string): string => `${SHARED_APP_PREFIX}${encodeURIComponent(token)}`;

export const appPath = (appKey: string): string => `/apps/${encodeURIComponent(appKey)}`;

export const isSharedAppPath = (pathname: string): boolean => pathname.startsWith(SHARED_APP_PREFIX);

export const appRunPath = ({
  appKey,
  runId,
}: Pick<ConversationAppRun, 'appKey' | 'runId'>): string =>
  `/apps/${encodeURIComponent(appKey)}/runs/${encodeURIComponent(runId)}`;
